module.exports = __webpack_public_path__ + "img/mashed_potatoes.575a3578.jpg";